"use client";

import { ButtonHTMLAttributes, forwardRef } from "react";

type Props = ButtonHTMLAttributes<HTMLButtonElement>;

const BASE_CLASSES =
  "inline-flex items-center justify-center gap-2 bg-primary text-white font-bold text-sm rounded-lg min-h-[48px] px-8 hover:bg-primary-hover active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-primary disabled:active:scale-100 transition-all duration-150";

const PrimaryCtaButton = forwardRef<HTMLButtonElement, Props>(
  function PrimaryCtaButton({ children, className, type = "button", ...rest }, ref) {
    return (
      <button
        ref={ref}
        type={type}
        className={className ? `${BASE_CLASSES} ${className}` : BASE_CLASSES}
        {...rest}
      >
        {children}
      </button>
    );
  }
);

export default PrimaryCtaButton;
